import { createFileRoute } from '@tanstack/react-router'
import { requireMember } from '@/lib/auth-guards'
import { MemberHomePage } from '@/features/member-home'

export const Route = createFileRoute('/_authenticated/member-home')({
  beforeLoad: requireMember,
  component: MemberHomePage,
})
